import { ExternalReactRenderers } from '../../../components/Editor/types';
import cn from 'classnames';
import { DaGalleryAttrs, DaGalleryOptions } from '../gallery';
import { TipTapBaseNode } from '../../../components/Viewer/renderer';
import { useWidth } from '../hooks/useWidth';
import { sanitizeUrl } from '@wix/da-url';
import { addMissingProtocol } from '../../../components/utils/validateHref';

import s from './Viewer.scss';

export interface Props {
  externalRenderers: ExternalReactRenderers;
  node: TipTapBaseNode;
}

const Viewer = (props: Props) => {
  const attrs: DaGalleryAttrs = props.node.attrs as DaGalleryAttrs;
  const {
    alignment,
    deviations,
    layout,
    linkOverrides,
    layoutRowAlignment,
    layoutSpacing,
    gridItemHeight,
    gridItemWidth,
    itemCropping,
    torpedoRowHeight,
  } = attrs;
  const Renderer = props.node.externalRenderers?.gallery;
  const config = props.node.extensionConfig?.gallery as DaGalleryOptions;
  const align =
    alignment === 'left'
      ? s['left']
      : alignment === 'right'
      ? s['right']
      : s['center'];

  const { width } = useWidth(
    attrs.width,
    config.defaultWidth,
    !!config.smallMedia,
    props.node.containerWidth
  );
  for (const key in linkOverrides) {
    linkOverrides[key] = sanitizeUrl(addMissingProtocol(linkOverrides[key]));
  }

  return (
    <div
      key={`gallery-`}
      className={cn(
        s['gallery-container'],
        s[`preset-${props.node.presetId}`],
        align
      )}
      data-da-type="da-gallery"
      data-width={attrs.width}
      data-alignment={alignment ?? config.defaultAlignment}
      data-layout={layout ?? config.defaultLayout}
      data-layoutspacing={layoutSpacing ?? config.defaultLayoutSpacing}
      data-layoutrowalignment={layoutRowAlignment}
      data-itemcropping={itemCropping}
      data-griditemwidth={gridItemWidth ?? config.defaultGridItemWidth}
      data-griditemheight={gridItemHeight ?? config.defaultGridItemHeight}
      data-torpedorowheight={torpedoRowHeight ?? config.defaultTorpedoRowHeight}
    >
      <Renderer
        deviations={deviations}
        width={width}
        extOptions={config}
        linkOverrides={linkOverrides}
        layoutSpacing={layoutSpacing}
        layoutRowAlignment={layoutRowAlignment}
        itemCropping={itemCropping}
        gridItemWidth={gridItemWidth}
        gridItemHeight={gridItemHeight}
        torpedoRowHeight={torpedoRowHeight}
        layout={layout}
      />
    </div>
  );
};

export default Viewer;
